import { VehicleBrand } from '../models/views.models';

const FIRST_YEAR = 2005;
const LAST_YEAR = 2026;

/** brand -> model -> [version, 0 km value in ARS]. A small hard-coded catalog is enough for M-06. */
const SOURCE: Record<string, Record<string, [string, number][]>> = {
  Toyota: {
    Corolla: [['XLI 2.0 CVT', 31000000], ['XEI 2.0 CVT', 34500000], ['SEG 2.0 CVT', 38000000]],
    Hilux: [['DX 4x2', 36000000], ['SRV 4x4 AT', 52000000]],
    Yaris: [['XS 1.5', 24000000], ['XLS 1.5 CVT', 27500000]],
  },
  Volkswagen: {
    'Gol Trend': [['Trendline', 17500000], ['Highline', 19500000]],
    Polo: [['Track', 22000000], ['Highline AT', 28500000]],
    Amarok: [['Trendline 4x2', 41000000], ['Highline V6 4x4', 58000000]],
  },
  Ford: {
    Ranger: [['XL 4x2', 38000000], ['XLT 4x4', 49000000], ['Limited 4x4 AT', 60000000]],
    Focus: [['SE 2.0', 21000000], ['Titanium 2.0 AT', 25500000]],
    EcoSport: [['SE 1.5', 23000000], ['Freestyle 1.5', 26000000]],
  },
  Chevrolet: {
    Cruze: [['LT 1.4T', 29000000], ['Premier 1.4T AT', 34000000]],
    Onix: [['LT 1.2', 19500000], ['Premier 1.0T AT', 25000000]],
    S10: [['LS 4x2', 37000000], ['High Country 4x4 AT', 55000000]],
  },
  Fiat: {
    Cronos: [['Drive 1.3', 20500000], ['Precision 1.3 CVT', 25500000]],
    Argo: [['Drive 1.3', 19000000], ['Trekking 1.3', 21500000]],
  },
  Renault: {
    Kwid: [['Zen 1.0', 14500000], ['Outsider 1.0', 16500000]],
    Sandero: [['Life 1.6', 17500000], ['Intens 1.6', 21000000]],
    Duster: [['Intens 1.6', 26500000], ['Iconic 1.3T 4x4', 35000000]],
  },
  Peugeot: {
    '208': [['Active 1.6', 22500000], ['Feline 1.6 AT', 28500000]],
    '2008': [['Allure 1.6', 28000000], ['GT 1.6T AT', 36500000]],
  },
};

function valuationOf(zeroKm: number, year: number): number {
  const age = LAST_YEAR - year;
  return Math.round((zeroKm * 0.9 ** age) / 100000) * 100000;
}

export const VEHICLE_CATALOG: VehicleBrand[] = Object.entries(SOURCE).map(([brand, models]) => ({
  name: brand,
  models: Object.entries(models).map(([model, versions]) => ({
    name: model,
    versions: versions.map(([version, zeroKm]) => ({
      name: version,
      years: Array.from({ length: LAST_YEAR - FIRST_YEAR + 1 }, (_, i) => {
        const year = LAST_YEAR - i;
        return { year, valuation: valuationOf(zeroKm, year) };
      }),
    })),
  })),
}));
